import EmptyData from '../../common/EmptyData';
import CurrencyTooltip from '../../currencytooltip/CurrencyTooltip';

const PnlStatementTable = ({ statementData, isPrint = undefined }) => {
      
    return (
        <>
        <div className={isPrint ? "" : "statement-body-scroll-wrapper"}>
        <table className={`table table-hover statement_table p-4 ${isPrint ? "statement_table_pdf" : ""}`}>
            {/* <table className="table table-hover statement_table p-4"> */}
                <colgroup>
                    <col style={{ width: '50%' }} />
                    <col style={{ width: '50%' }} />
                </colgroup>
                <thead className={isPrint ? "statement_table_header_pdf" : "statement_table_header"}>
                    <tr>
                        <th className='normal_text grey_subtext1 fw-500 text-uppercase ' scope="col">Amount</th>
                        <th className='normal_text grey_subtext1 text-end fw-500 text-uppercase' scope="col">Total</th>
                    </tr>
                </thead>
                <tbody className={isPrint ? "statement_table_header_pdf" : "statementbody"} >
                    {statementData && statementData?.incomeItems?.length > 0 || statementData && statementData?.expenseItems?.length > 0 ? (
                        <>{statementData && statementData?.incomeItems?.length > 0 &&
                                <>
                                    <tr>
                                        <td className='normal_text fw-bold grey_subtext1'>
                                            Income
                                        </td>
                                        <td></td>
                                    </tr>
                                    {statementData && statementData?.incomeItems?.map((data, index) => (
                                        <tr key={index} className='data_row'>
                                            <td className='normal_text grey_subtext1'>{data.description}</td>
                                            <td className='normal_text grey_subtext1 text-end'>
                                                <CurrencyTooltip content={data.formatted?.AmountRaw} formatted={data.formatted?.Amount}>
                                                    <span>{`[[currency]]${data.formatted?.Amount || data.amount}`}</span>
                                                </CurrencyTooltip>
                                            </td>
                                        </tr>
                                    ))}
                                </>
                            }

                            <tr className='totalIncome'>
                                <td className='normal_text grey_subtext1 fw-bold'>Total Income</td>
                                <td className='normal_text grey_subtext1 fw-bold text-end'>
                                    <CurrencyTooltip content={statementData?.formatted?.IncomeRaw} formatted={statementData?.formatted?.Income}>
                                        <span>{`[[currency]]${statementData?.formatted?.Income || statementData?.income}`}</span>
                                    </CurrencyTooltip>
                                </td>
                            </tr>

                            {/* Expenses Section */}
                            {statementData && statementData?.expenseItems?.length > 0 &&
                                <>
                                    <tr>
                                        <td className='normal_text fw-bold grey_subtext1'>Expenses</td>
                                        <td></td>
                                    </tr>
                                    {statementData && statementData?.expenseItems?.map((data, index) => (
                                        <tr key={index} className='data_row'>
                                            <td className='normal_text grey_subtext1'>{data.description}</td>
                                            <td className='normal_text grey_subtext1 text-end'>
                                                <CurrencyTooltip content={data.formatted?.AmountRaw} formatted={data.formatted?.Amount}>
                                                    <span>{`[[currency]]${data.formatted?.Amount || data.amount}`}</span>
                                                </CurrencyTooltip>
                                            </td>
                                        </tr>
                                    ))}
                                </>
                            }

                            <tr>
                                <td className='normal_text grey_subtext1 fw-bold'>Total Expenses</td>
                                <td className='normal_text grey_subtext1 fw-bold text-end'>
                                    <CurrencyTooltip content={statementData?.formatted?.ExpensesRaw} formatted={statementData?.formatted?.Expenses}>
                                        <span>{`[[currency]]${statementData?.formatted?.Expenses || statementData?.expenses}`}</span>
                                    </CurrencyTooltip>
                                </td>
                            </tr>

                            {/* Net Operating Income */}
                            {statementData && statementData?.netIncome !== 0 &&
                                <tr className='netOperatingIncome'>
                                    <td className='normal_text grey_subtext1 fw-bold'>Net Operating Income</td>
                                    <td className='normal_text grey_subtext1 fw-bold text-end'>
                                        <CurrencyTooltip content={statementData?.formatted?.NetIncomeRaw} formatted={statementData?.formatted?.NetIncome}>
                                            <span>{`[[currency]]${statementData?.formatted?.NetIncome || statementData?.netIncome}`}</span>
                                        </CurrencyTooltip>
                                    </td>
                                </tr>
                            }
                        </>
                    ) :
                        <tr>
                            <td colSpan={2}>
                                <EmptyData mainText="No Data Found" subText={undefined} button={undefined} />
                            </td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>
        </>
    );
}

export default PnlStatementTable;
